<template>
  <div class="conrainer">
       <BigScreenHead>
          <template v-slot:center >
              <div class="head-title">销 售 管 理 板 块</div>
          </template>
        </BigScreenHead>
        <main>
            <div class="left">
                <div class="leftinfo">
                    <div class="leftinfo-left">
                        <div class="item" >
                            <div class="item-top">
                                <p class="item-top-title">全公司本年度销量</p>
                                <p class="item-top-count">{{companyIndex.yearSaleNum}}</p>
                            </div>
                            <div class="item-bot">
                                <p class="item-bot-title">
                                    <span>本月销量</span>
                                    <span style="margin-left:23%">环比</span>
                                </p>
                                <p class="item-bot-count">
                                    <span>{{companyIndex.yearSaleNum}}</span>
                                    <span style="margin-left:23%;color:#bf0000">+{{companyIndex.ratio}}%</span>
                                </p>
                            </div>
                        </div>
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="item swiper-slide" v-for="(item,i) in companyList" :key="i">
                                    <div class="item-top">
                                        <p class="item-top-title">{{item.shortName}}</p>
                                        <p class="item-top-count">{{item.yearSaleNum}}</p>
                                    </div>
                                    <div class="item-bot">
                                        <p class="item-bot-title">
                                            <span>本月销量</span>
                                            <span style="margin-left:23%">环比</span>
                                        </p>
                                        <p class="item-bot-count">
                                            <span>{{item.monthSaleNum}}</span>
                                            <span style="margin-left:23%;color:#bf0000">+{{item.ratio}}%</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="leftinfo-chart"></div>
                </div>
                <div class="leftbot">
                    <div class="map"></div>
                    <div class="leftbot-right">
                        <div class="leftbot-info">
                            <div class="leftbot-info-item" >
                                <div class="leftbot-info-item-left" style="margin-left:5%">
                                    <p>客户总数</p>
                                    <p style="margin-top:6%;color:#EDB941;font-size:25px;font-weight:500;">{{customerInfo.customerTotal}}<span style="font-size:12px;color:#fff">家</span></p>
                                </div>
                                <div class="leftbot-info-item-right" style="margin-left:18%;margin-bottom:15%">
                                    <div class="huanbi-top">
                                        <i class="iconfont" :style="{color:customerInfo.yearCustomerRatio>0?'#bf0000':'#6D9E7B'}">{{customerInfo.yearCustomerRatio>0?'&#xe60d;':'&#xe60e;'}}</i>
                                        <p style="font-size:20px">{{customerInfo.yearCustomerRatio}}%</p>
                                    </div>
                                    <div class="huanbi-bot">
                                        {{customerInfo.yearCustomerRatio>0?'环比增长':'环比减少'}}
                                        <div class="henxian">
                                            <div class="xiexian"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="leftbot-info-item" >
                                <div class="leftbot-info-item-left" style="margin-left:5%">
                                    <p>今年新增</p>
                                    <p style="margin-top:6%;color:#EDB941;font-size:25px;font-weight:500;">{{customerInfo.yearCustomerTotal}}<span style="font-size:12px;color:#fff">家</span></p>
                                </div>
                                <div class="leftbot-info-item-right" style="margin-left:18%;margin-bottom:15%">
                                    <div class="huanbi-top">
                                        <i class="iconfont" :style="{color:customerInfo.yearCustomerRatio>0?'#bf0000':'#6D9E7B'}">{{customerInfo.yearCustomerRatio>0?'&#xe60d;':'&#xe60e;'}}</i>
                                        <p style="font-size:20px">{{customerInfo.yearCustomerRatio}}%</p>
                                    </div>
                                    <div class="huanbi-bot">
                                        {{customerInfo.yearCustomerRatio>0?'环比增长':'环比减少'}}
                                        <div class="henxian">
                                            <div class="xiexian"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="leftbot-info-item" >
                                <div class="leftbot-info-item-left" style="margin-left:5%">
                                    <p>本月新增</p>
                                    <p style="margin-top:6%;color:#EDB941;font-size:25px;font-weight:500;">{{customerInfo.monthCustomerTotal}}<span style="font-size:12px;color:#fff">家</span></p>
                                </div>
                                <div class="leftbot-info-item-right" style="margin-left:18%;margin-bottom:15%">
                                    <div class="huanbi-top">
                                        <i class="iconfont" :style="{color:customerInfo.monthCustomerRation>0?'#bf0000':'#6D9E7B'}">{{customerInfo.monthCustomerRation>0?'&#xe60d;':'&#xe60e;'}}</i>
                                        <p style="font-size:20px">{{customerInfo.monthCustomerRation}}%</p>
                                    </div>
                                    <div class="huanbi-bot">
                                        {{customerInfo.monthCustomerRation>0?'环比增长':'环比减少'}}
                                        <div class="henxian">
                                            <div class="xiexian"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="leftbot-chart-box">
                            <div class="leftbot-chart-title">客户性质画像</div>
                            <div class="leftbot-chart-big">
                                <div class="leftbot-chart leftbot-chart1"></div>
                                <div class="leftbot-chart leftbot-chart2"></div>
                                <div class="leftbot-chart leftbot-chart3"></div>
                            </div>
                        </div>
                        <div class="leftbot-ul-box">
                            <div class="left-ul">
                                <div style="border-top:1px solid #fff">
                                    <p style="border-left:1px solid #fff">省份</p>
                                    <p>客户数量</p>
                                </div>
                                <div style="border-top:1px solid #fff">
                                    <p>省份</p>
                                    <p>客户数量</p>
                                </div>
                                <div style="border-top:1px solid #fff">
                                    <p>省份</p>
                                    <p>客户数量</p>
                                </div>
                                <div style="border-top:1px solid #fff">
                                    <p>省份</p>
                                    <p>客户数量</p>
                                </div>
                                <div v-for="(item,i) in provinceList" :key="i">
                                    <p :style="{borderLeft:(i%4==0)?'1px solid #fff':''}">
                                        <span v-overflow>{{item.areaName}}</span>
                                    </p>
                                    <p>
                                        <span v-overflow style="color:#EDB941">{{item.areaCount}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="leftbot-fot">
                            <!-- <div @click="porvincePrev">上一页</div>
                            <div style="margin:0 2%;">第{{pageForm.pageIndex}}页 共{{provinceTotal}}条</div>
                            <div @click="porvinceNext">下一页</div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="right-title">客户购买力排行榜</div>
                <div class="search">
                    <input type="text" placeholder="输入客户名称关键字" id="saleFilter" >
                    <button @click="purchasingPowerSearch">查 询</button>
                </div>
                <div class="right-ul-box">
                    <table>
                        <tr>
                            <td style="width:10%"></td>
                            <td>客户名称</td>
                            <td style="width:20%">设备数量</td>
                            <td style="width:20%">详情</td>
                        </tr>
                        <tr v-for="(item,i) in payPowerList" :key="i">
                            <td>{{i+1}}</td>
                            <td><span v-overflow style="width:95%">{{item.name}}</span></td>
                            <td><span v-overflow style="width:95%">{{item.count}}</span></td>
                            <td><button v-if="item.name!='' && item.id" @click="toCompany(item.id)">查 看</button></td>
                        </tr>
                    </table>
                </div>
                <div class="right-page">
                    <div @click="purchasingPowerPrev">上一页</div>
                    <div style="margin:0 2%;">第{{filterForm.pageIndex}}页 共{{payPowerTotal}}条</div>
                    <div @click="purchasingPowerNext">下一页</div>
                </div>
            </div>
        </main>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { xiaoshouLine,xiaoshouMap,xiaoshouPie1,xiaoshouPie2 } from '../assets/js/echarts'
export default {
    data(){
        return{
            companyinfo:[],
            customerInfo:{},
            companyIndex:{
                yearSaleNum: 0,
                monthSaleNum: 0,
                ratio: 0
            },
            companyList:[],
            pageForm:{
                pageSize:50,
                pageIndex:1
            },
            filterForm:{
                filter:"",
                pageSize:17,
                pageIndex:1
            },
            provinceTotal:0,
            provinceList:[],
            payPowerTotal:0,
            payPowerList:[]
        }
    },
    methods:{
        //swiper轮播
        swiperInit(flag){
            this.$nextTick(()=>{
                var mySwiper = new Swiper(".swiper-container", {
                    slidesPerView: 4,
                    loopedSlides: 4,
                    speed: 1200, //滑动速度
                    loop: flag,
                    spaceBetween: 0, //每个元素的间距
                    grabCursor: true, //出现手型
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false, //鼠标操作后不会停止
                    },
                });
                 mySwiper.el.onmouseover = function () {
                    mySwiper.autoplay.stop();
                };
                mySwiper.el.onmouseleave = function () {
                    mySwiper.autoplay.start();
                };
            })
        },
        //格式化表格，没有15个数据时填满15个
        listFomart(option){
            if(option.length < 15){
                for(let i=option.length; i<15; i++){
                    option.push({})
                }
            }
        },
        //设备产量信息
        getCompanyListInfo(){
            this.$api.CompanyYearSaleInfo().then(res=>{
                var value = res.data.data;
                this.companyIndex.yearSaleNum = value.yearSaleNum;
                this.companyIndex.monthSaleNum = value.monthSaleNum;
                this.companyIndex.ratio = value.ratio;
                this.companyList = value.companyList;
                if(this.companyList.length >= 4){
                    this.swiperInit(true)
                }else{
                    this.swiperInit(false)
                }
                xiaoshouLine({doc:'.leftinfo-chart'},this.companyList);
            })

        },
        getCustomerInfo(){
            this.$api.CustomerNatureInfo().then(res=>{
                this.customerInfo = res.data.data;
                xiaoshouPie1({doc:'.leftbot-chart1',title:'企业性质',data:[{ name:'央企',value:this.customerInfo.centralEnterprises },{ name:'国企',value:this.customerInfo.stateEnterprise },{ name:'民企',value:this.customerInfo.privateEnterprise },{ name:'其他',value:this.customerInfo.otherEnterprise }]});
                xiaoshouPie1({doc:'.leftbot-chart3',title:'客户粘性（按交易年数）',data:[{ name:'一年内',value:this.customerInfo.withinOneYear },{ name:'3年',value:this.customerInfo.withinThreeYear },{ name:'3-5年',value:this.customerInfo.withinFiveYear },{ name:'5年以上',value:this.customerInfo.moreThanFiveYears }]})
                xiaoshouPie2({doc:'.leftbot-chart2',title:'行业性质',data:[{ name:'建筑商',value:this.customerInfo.builder },{ name:'租赁商',value:this.customerInfo.leaseholder },{ name:'其他',value:this.customerInfo.otherTrader }]})                
            })
        },
        getPorvinceInfo(){
            this.$api.ProvinceCustomerVolumeInfo(this.pageForm).then(res=>{
                this.provinceTotal = res.data.data.total;
                var list = res.data.data.data;
                for(let i=list.length; i<36; i++){
                    list.push({
                        areaName:'',
                        areaCount: '',
                    })
                }
                this.provinceList = list;
            })
        },
        //上一页
        porvincePrev(){
            if (this.pageForm.pageIndex <= 1) return;
            this.pageForm.pageIndex --;
            this.getPorvinceInfo();
        },
        //下一页
        porvinceNext(){
            var listLength = this.pageForm.pageIndex * this.pageForm.pageSize;
            if(this.provinceTotal <= listLength) return;
            this.pageForm.pageIndex ++;
            this.getPorvinceInfo();
        },
        getPurchasingPowerInfo(){
            this.filterForm.filter = document.getElementById("saleFilter").value;
            this.$api.CustomerPurchasingPowerInfo(this.filterForm).then(res=>{
                this.payPowerTotal = res.data.data.total;
                var list = res.data.data.data;
                if(list.length < 18){
                    for(let i=list.length; i<17; i++){
                        list.push({})
                    }
                }
                this.payPowerList = list;
            })
        },
        //查询
        purchasingPowerSearch(){
            this.filterForm.pageSize = 17,
            this.filterForm.pageIndex = 1,
            this.getPurchasingPowerInfo();
        },
        //上一页
        purchasingPowerPrev(){
            if (this.filterForm.pageIndex <= 1) return;
            this.filterForm.pageIndex --;
            this.getPurchasingPowerInfo();
        },
        //下一页
        purchasingPowerNext(){
            var listLength = this.filterForm.pageIndex * this.filterForm.pageSize;
            if(this.payPowerTotal <= listLength) return;
            this.filterForm.pageIndex ++;
            this.getPurchasingPowerInfo();
        },
        getSalesHeatInfo(){
            this.$api.SalesHeatChartInfo().then(res=>{
                var total = res.data.data.total;
                var list = res.data.data.data;
                xiaoshouMap({doc:'.map'},list);                
            })
        },
        //查看按钮
        toCompany(id){
            this.$router.push('/CompanyBigScreen?id='+id)
        },
    },
    mounted(){
        this.getCustomerInfo();
        this.getCompanyListInfo();
        this.getPorvinceInfo();
        this.getPurchasingPowerInfo();
        this.getSalesHeatInfo();
    }
}
</script>

<style lang="scss" scoped>
.swiper-container {
    width: 100%;
    height: 100%;
}
.iconfont{
    font-family:"iconfont" !important;
    font-size: 27px;
    font-style: normal;
    color: #bf0000;
}
.conrainer{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: url('../assets/images/bigScreen_back.webp') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    color: #fff;
}
.head-title{
    font-size: 1.5625rem;
    font-weight: bold;
    letter-spacing: 5px;
}
main{
    flex: 1;
    width: 100%;
    display: flex;
    padding: 0 1.2rem;
}
.left{
    width: 78%;
    display: flex;
    flex-direction: column;
}
.right{
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: 0.7rem;
}
.leftinfo{
    height: 11rem;
    display: flex;
}
.leftinfo-left{
    width: 70%;
    display: flex;
}
.leftinfo-chart{
    flex: 1;
}
.item{
    height: 100%;
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 2%;
}
.swiper-slide{
    margin-right: 1px;
}
.item-top-count{
    margin-top: 4%;
    font-size: 1.7rem;
    color: #EDB941;
}
.item-bot-count{
    margin-top: 4%;
    font-size: 1.3rem;
    display: flex;
    span{
        width: 50%;
        display: block;
    }
}
.item-bot-title{
    color: #ccc;
    display: flex;
    span{
        width: 50%;
        display: block;
    }
}
.item-top{
    font-weight: 600;
}
.item-bot{
    margin-top: 12%;
    font-weight: 400;
}
.leftbot{
    flex: 1;
    display: flex;
}
.map{
   width: 54%;
}
.leftbot-right{
    flex: 1;
    display: flex;
    flex-direction: column;
}
.leftbot-info{
    height: 6.7rem;
    display: flex;
    padding-top: 2%;
}
.leftbot-info-item{
    display: flex;
    flex: 1;
    align-items: center;
}
.leftbot-chart-box{
    height: 13rem;
    display: flex;
    flex-direction: column;
}
.huanbi-top{
    display: flex;
}
.huanbi-bot{
    margin-top:5%;
    margin-left: 10%;
    font-size:14px;
    border: 1px solid #fff;
    text-align: center;
    width: 4.125rem;
    height: 1.5625rem;
    line-height: 1.4375rem;
    position: relative;
    .henxian{
        background: #fff;
        position: absolute;
        height: 1px;
        width: 1.25rem;
        left: -1.25rem;
        top: -1px;
    }
    .xiexian{
        background: #fff;
        position: absolute;
        height: 1px;
        width: 37px;
        top: 10px;
        left: -32px;
        transform: rotate(-35deg);
    }
}
.leftbot-chart-title{
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    padding: 1px 0;
    letter-spacing: 3px;
}
.leftbot-chart-big{
    display: flex;
    flex: 1;
}
.leftbot-chart{
    flex: 1;
}
.leftbot-ul-box{
    flex: 1;
    margin-top: 1%;
    .left-ul{
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        div{
            height: 10%;
            display: flex;
            width: 25%;
            p{
                border-bottom: 1px solid #fff;
                border-right: 1px solid #fff;
                width: 50%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 5px;
                font-size: 0.9375rem;
            }
        }
    }
}
.leftbot-fot{
    height: 7%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9375rem;
    & div{ cursor: pointer;}
    & div:active{ color: #EDB941;}
}
.right-title{
    height: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    letter-spacing: 2px;
    font-size: 1.125rem;
}
.search{
    height: 6%;
    display: flex;
    align-items: center;
    input{
        height: 60%;
        width: 65%;
        background: none;
        border: 1px solid #fff;
        border-radius: 5px;
        padding-left: 10px;
        color: #fff;
    }
    button{
        background: #EDB941;
        color: #fff;
        font-size: 14px;
        margin-left: 1rem;
        width: 3.5rem;
        height: 1.5rem;
        border-radius: 4px;
        padding: 0;
        cursor: pointer;
        line-height: 0;
        &:active{
            background: rgba($color: #EDB941, $alpha: 0.9);
        }
    }
}
.right-ul-box{
    flex: 1;
    table{
        width: 100%;
        height: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        overflow: hidden;
        td{
            border: 1px solid #fff;
            text-align: center;
            font-size: 0.9375rem;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
        button{
            background: #EDB941;
            color: #fff;
            width: 60%;
            height: 53%;
            border-radius: 5px;
            cursor: pointer;
            line-height: 0;
        }
        button:active{background: rgba($color: #EDB941, $alpha: 0.9);}
    }
}
.right-page{
    height: 5.5%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9375rem;
    & div{ cursor: pointer;}
    & div:active{ color: #EDB941;}
}
</style>